import React, { Key, useCallback, useEffect, useState } from "react";
import { Table } from "antd";
import { useClient } from "../../../../hooks/ClientProvider";
import { CompanyParams } from "../../../../Context/companyContext";
import api from "../../../../services/api";
import { notifyError, notifySucces } from "../../../../utils/notifications";
import { TAnnuity, TUseModalListAnnuity } from "./types";
import { getPlaces } from "../../../../utils/getStores";
import { useAuth } from "../../../../hooks/AuthProvider";

export const useModalListAnnuity = ({
  closeModal,
  reloadPremiumAnnuity,
  open,
}: TUseModalListAnnuity) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
  const [annuity, setAnnuity] = useState<TAnnuity>({} as TAnnuity);
  const [loading, setLoading] = useState(false);
  const [openStoreModal, setOpenStoreModal] = useState<boolean>(false);
  const { client } = useClient();
  const { companyParams } = CompanyParams();
  const { user } = useAuth();

  const userStores: string[] = String(user?.store ?? "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  const columnPremiumAnnuity = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Descricao",
      dataIndex: "descricao",
      key: "descricao",
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      render: (valor: string) => (
        <span>R$ {String(valor).replace(".", ",")}</span>
      ),
    },
    Table.SELECTION_COLUMN,
  ];

  const getAnnuityData = async () => {
    const { data } = await api.get(`client/${client?.client?.id}/annuity`);
    if (data.isBonificada) {
      setSelectedRowKeys([data.id]);
    }
  };

  useEffect(() => {
    if (companyParams?.has_annuity) {
      getAnnuityData();
    }
  }, [companyParams]);

  const handleEngage = useCallback(async () => {
    try {
      setLoading(true);
      if (userStores.length === 1) {
        const { data: phones } = await api.get("client_contacts", {
          client_id: client.client.id,
        });

        if (phones.length === 0) {
          notifyError("Erro! Nenhum telefone cadastrado");
          return;
        }
        const hasBonusPhone = phones.find(
          (phone: any) => phone.utilizadoTaxaBonificada
        );

        if (!hasBonusPhone && annuity?.isBonificada) {
          notifyError(
            "Erro! O cliente não possui nenhum celular com disponibilidade para recebimento de bônus. Tente novamente!"
          );
          return;
        }

        await api.patch(`client/${client.client.id}/annuity`, {
          id_anuidade: selectedRowKeys[0],
          nome_anuidade: annuity?.descricao,
          valor_anuidade: annuity?.valor,
          id_loja: userStores[0],
        });

        notifySucces("Anuidade bonificada foi contratada com sucesso!");
        reloadPremiumAnnuity();
        return;
      }

      setOpenStoreModal((prev) => !prev);
    } catch (err) {
      notifyError("Falha ao contratar anuidade");
    } finally {
      setLoading(false);
      closeModal();
    }
  }, [client, annuity, selectedRowKeys, reloadPremiumAnnuity, closeModal]);

  const onSelectChange = (newSelectedRowKeys: any, annuitySelected: any) => {
    setAnnuity(annuitySelected[0]);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return {
    loading,
    rowSelection,
    columnPremiumAnnuity,
    handleEngage,
    openStoreModal,
    setOpenStoreModal,
    userStores,
    selectedRowKeys,
    annuity,
  };
};
